var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 36.4729L18.0232 34.2179C9.22533 26.24 3.41699 20.9612 3.41699 14.5208C3.41699 9.24208 7.55116 5.125 12.8128 5.125C15.7853 5.125 18.6382 6.50875 20.5003 8.67833C22.3624 6.50875 25.2153 5.125 28.1878 5.125C33.4495 5.125 37.5837 9.24208 37.5837 14.5208C37.5837 20.9612 31.7753 26.24 22.9774 34.2179L20.5003 36.4729Z",
    fill: "#DB3353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3241a1026f8a74a9b062fe92bba71e13.svg";
export { ForwardRef as ReactComponent };